import { render } from "./externalUrlComponent.vue?vue&type=template&id=7dc39a22&scoped=true"
import script from "./externalUrlComponent.vue?vue&type=script&lang=js"
export * from "./externalUrlComponent.vue?vue&type=script&lang=js"

import "./externalUrlComponent.vue?vue&type=style&index=0&id=7dc39a22&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc39a22"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/externalUrlComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7dc39a22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7dc39a22', __exports__)) {
    api.reload('7dc39a22', __exports__)
  }
  
  module.hot.accept("./externalUrlComponent.vue?vue&type=template&id=7dc39a22&scoped=true", () => {
    api.rerender('7dc39a22', render)
  })

}


export default __exports__